<template>
  <div class="mine container" :class="{ 'side-collapsed': sideCollapsed }">
    <side class="side" @collapse-change="onSideCollapse"></side>
    <div class="rightMain">
      <keep-alive>
        <router-view/>
      </keep-alive>
    </div>
  </div>
</template>

<script>
import Side from './components/side'

export default {
  name: 'Mine',
  components: { Side },

  data () {
    return {
      sideCollapsed: localStorage.getItem('mine-side-collapsed') === '1', // 把 collapsed 的初始值直接从 localStorage 读，不再等 mounted,防止组件重建时会先渲染展开态（false），再变成收起态（true），css展开收起动画会闪一下
    }
  },

  methods: {
    onSideCollapse (val) {
      this.sideCollapsed = val
    }
  }
}
</script>

<style lang='scss' scoped>
$side-width: 192px;
$side-collapsed-width: 64px;

.mine.container {
  background: #fff;
  box-shadow: 0px 6px 16px 0px rgba(0, 109, 117, 0.06);
  border-radius: 8px;
  margin: 16px auto;
  min-height: 670px;
  padding-right: 0;
}

.mine {
  position: relative;
  padding-left: $side-width;
  transition: padding-left .25s ease;

  .side {
    width: $side-width;
    position: absolute;
    left: 0;
    top: 0;
    bottom: 0;
    transition: width .25s ease;
  }

  /* 收起状态：内容区变宽 */
  &.side-collapsed {
    padding-left: $side-collapsed-width;

    .side {
      width: $side-collapsed-width;
    }
  }
}

.rightMain {
  width: 100%;
  min-width: 0; /* 防止内容溢出 */
}

@media screen and (max-width: 991px) {
  .mine .side {
    position: inherit;
    width: 100%;
  }

  .mine.container {
    padding-left: 0;
  }

  /* 移动端禁用收起 */
  .mine.side-collapsed {
    padding-left: 0;

    .side {
      width: 100%;
    }
  }
}
</style>